// The session id groups one visitor's editor events in GTM, so two live sessions drawing the same
// id silently merge their funnels. A million-value range collides after roughly a thousand
// sessions; drawing 32 unsigned bits from the platform CSPRNG spreads ids over the full range and
// keeps them unpredictable.
const createAppSessionId = () => crypto.getRandomValues(new Uint32Array(1))[0];

export default createAppSessionId;
